import { flow, observable, action } from "mobx";
import { getUserEmails, deleteEmails, addEmail } from "services/emails";
import { registerHandler, testEmail } from "services/api";
import { message } from "antd";

class EmailStore {
    constructor() {        
        this.ui = this.getUI();
    }

    @observable
    emails = [];

    getUI = () => {
        let ui = {
            loadingEmails: false,
            importEmailsDialogVisible: false,
            addEmailDialogVisible: false,
            importingEmails: false,
            addingEmail: false,
            testingEmail: false,
            importedEmails: [],
            currentEmail: {},            
            deletedEmails: []            
        }
        return observable.object(ui);
    }

    @action
    showImportEmailsDialog = () => {
        this.ui.importEmailsDialogVisible = true;
    }

    @action
    hideImportEmailsDialog = () => {
        this.ui.importEmailsDialogVisible = false;
    }

    @action
    showAddEmailDialog = () => {
        this.ui.addEmailDialogVisible = true;
    }

    @action
    hideAddEmailDialog = () => {
        this.ui.addEmailDialogVisible = false;
    }

    @action
    importEmails = (importedEmails) => {
        this.ui.importedEmails = observable.array(importedEmails);
    }

    remoteTestEmail = flow(function*(emailAccount) {   
        this.ui.testingEmail = true;     
        const response = yield testEmail(emailAccount);        
		this.ui.testingEmail = false;

		if (!response) {
			message.error("Failed to login the email address. Unknown error");
			return;
		}

		if (response.error) {
			message.error(response.error.message);
			return;
		}

		message.success("Successfully logged in to the email address");
    })

    remoteAddEmail = flow(function*(emailAccount) {
        const response = yield addEmail(emailAccount);
        
        if (response == null) {
            message.error("Failed to add email account. Unknown error");
            return;
        }

        if (response.error) {
            message.error(response.error.message, 5);
            return;
        }

        message.success("Successfully added email account");

        this.ui.addEmailDialogVisible = false;
    })

    remoteDeleteEmails = flow(function*(addresses) {
		const response = yield deleteEmails(addresses);

		if (response == null) {
			message.error("Failed to delete the accounts", 5);
			return;
		}

		if (response.error) {
			message.error(response.error.message, 5);
			return;
		}

		message.success("Successfully deleted the accounts", 3);

		// for (let i = this.accounts.length - 1; i >= 0; i--) {
		// 	let account = this.accounts[i];
		// 	if (account.checked) {
		// 		this.accounts.splice(i, 1);
		// 	}
		// }
    });
    
    @action
	deleteEmails = deletedEmails => {
		this.ui.deletedEmails = observable.array(deletedEmails);
    };
        
    loadEmails = flow(function*() {
        this.ui = this.getUI();
        this.ui.loadingEmails = true;
        const response = yield getUserEmails();
        if (response == null) {
            message.error("Failed to load emails. Unknown error", 5);
            return;
        }
        if (response.error) {
            message.error(response.error.message, 5);
            return;
        }

        this.ui.loadingEmails = false;
        this.emails = observable.array(response.emails);
        message.success("Successfully load emails");        
        registerHandler([
			{
				path: "email_manager",
				handler: (err, msg) => {
					if (err) {
						return;
					}
					var obj = JSON.parse(msg.body);

					if (obj.action == "emailsInserted") {
						this.importEmails(obj.emails);
						return;
					}
					if (obj.action == "emailsDeleted") {
						this.deleteEmails(obj.emails);
						return;
					}
					// if (obj.action == "accountEdited") {
					// 	this.updateAccount(obj.account);
					// }
					// if (obj.action == "accountsImported") {
					// 	this.importAccounts(obj.accounts);
					// }
				}
			}
		]);         
    })
}

export default EmailStore;